
import React, { useState, Fragment } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Table, Drawer } from 'antd';
import dayjs from 'dayjs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import H3Text from '@Uilib/h3Text';
import QCPointActions from '@Actions/quality/qcPointActions';
import CategoryActions from '@Actions/categoryActions';
import ProductActions from '@Actions/productActions';
import {
  QUANTITY, INFINITE_EXPIRY_DATE,
} from '@Apis/constants';
import QualityCheckActions from '@Actions/quality/qualityCheckActions';
import './style.scss';
import { Tooltip } from 'antd';
import ApproveQC from '../../../../../Quality/QualityChecks/ListQualityChecks/ApproveQC';

/**
 *
 */
const QualityCheckGRN = ({
  selectedGRNLines, user, callback, getDownloadQualityChecks,
}) => {
  const [showApproveQualityCheck, setShowApproveQualityCheck] = useState(false);
  const [selectedQC, setSelectedQC] = useState({});

  const getQCStatusColor = (status) => {
    if (status === 'COMPLETED') return { color: '#2fbc6e', text: 'Completed' };
    if (status === 'PENDING') return { color: '##dcaa06', text: 'Pending' };
    return { color: '#dcaa06', text: status };
  };

  const getQCColumns = () => {
    const qcColumns = [
      {
        title: '',
        responsive: ['xs'],
        render: (item) => (
          <div className="mobile-list__item">
            <H3Text text={`QC# : ${item?.qc_number}`} className="mobile-list__item-number" />
            <Link to={`/inventory/product/view/${item?.product_sku_info?.product_sku_id}`} target="_blank">
              <H3Text text={`SKU# : ${item?.product_sku_info?.internal_sku_code}`} className="mobile-list__item-number" />
            </Link>
            <H3Text text={`Product Name: ${item?.product_sku_info?.product_sku_name}`} className="mobile-list__item-info" />
            <H3Text text={`Batch Number: ${item?.batch_number}`} className="mobile-list__item-info" />
            <H3Text text={`Batch Qty: ${QUANTITY(item?.quantity || '0', item?.uom_info[0]?.precision)} ${item?.uom_info?.[0]?.uqc?.toProperCase()})`} className="mobile-list__item-info" />
            <H3Text text={`Approved Qty: ${QUANTITY(item?.approved_qty, item?.uom_info?.precision)} ${item?.uom_info?.[0]?.uqc?.toProperCase()})`} className="mobile-list__item-info" />
            <H3Text text={`Rejected Qty: ${QUANTITY(item?.rejected_qty || '0', item?.uom_info[0]?.precision)} ${item?.uom_info[0]?.uqc?.toProperCase()}`} className="mobile-list__item-info" />
          </div>
        ),
      },
      {
        title: 'QC#',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        fixed: 'left',
        render: (record) => (
          <React.Fragment>
            <div>
              {record?.qc_number || '-'}
            </div>
            <div className="qr__status" style={{ backgroundColor: getQCStatusColor(record?.status).color }}>
              {record?.is_qc_on_hold ? 'On hold' : record.status?.toProperCase()}
            </div>
          </React.Fragment>
        ),
      },
      {
        title: 'SKU#',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (record) => (
          <div>
            <Tooltip
              title={(
                <div
                  style={{
                    color: 'rgb(0, 0, 0)',
                    fontSize: '12px',
                    fontWeight: '500',
                    padding: '2px',
                  }}
                >
                  {record?.product_sku_info?.product_category_info?.category_path?.join(' / ')}
                </div>
              )}
              color="rgb(234, 242, 254)"
            >
              <Link to={`/inventory/product/view/${record?.product_sku_info?.product_sku_id}`} target="_blank">
              {record?.product_sku_info?.internal_sku_code}
              </Link>
            </Tooltip>
            <div style={{ minWidth: '200px' }}>
              {record?.product_sku_info?.product_sku_name}
              <H3Text text={`Batch #${record?.custom_batch_number || record?.batch_number}`} className="" />
              {dayjs(record?.expiry_date)?.format('YYYY-MM-DD') !== INFINITE_EXPIRY_DATE && <H3Text text={`Expires on ${dayjs(record?.expiry_date).format('DD MMM, YY')}`} />}
              <H3Text text={record.remarks} className="quotation__remarks" />
            </div>
          </div>
        ),
      },
      {
        title: 'Batch Qty',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (item) => <H3Text text={`${QUANTITY((Number(item?.original_qty || item?.quantity || 0) + Number(item?.sample_quantity || 0)), item?.uom_info[0]?.precision)} ${item?.uom_info[0]?.uqc?.toProperCase()}`} />,
      },
      {
        title: 'Sample Qty',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (item) => <H3Text text={`${QUANTITY(Number(item?.sample_quantity || 0), item?.uom_info[0]?.precision)} ${item?.uom_info[0]?.uqc?.toProperCase()}`} />,
      },
      {
        title: 'Approved Qty',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (item) => <H3Text text={`${QUANTITY(item?.approved_qty || '0', item?.uom_info[0]?.precision)} ${item?.uom_info[0]?.uqc?.toProperCase()}`} />,
      },
      {
        title: 'Rejected Qty',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (item) => <H3Text text={`${QUANTITY(item?.rejected_qty || '0', item?.uom_info[0]?.precision)} ${item?.uom_info[0]?.uqc?.toProperCase()}`} />,
      },
      {
        title: ' ',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        key: 'action',
        className: 'list__actions-column',
        fixed: 'right',
        render: (item) => (
          <div className="list__actions">
            <div
              className="list__actions-button"
              onClick={() => {
                setSelectedQC(item);
                setShowApproveQualityCheck(true);
              }}
            >
              View
            </div>
            <div
              className="list__actions-button list__actions-button-download"
              onClick={() => {
                if (['COMPLETED'].includes(item?.status)) {
                  getDownloadQualityChecks(item?.quality_control_rules?.tenant_id, item?.quality_check_id);
                }
              }}
            >
              <div
                className={` ${!['COMPLETED'].includes(item?.status) ? 'list__actions-button-download-disabled' : ''}`}
                style={{ marginLeft: '5px', marginRight: '5px' }}
              >
                <H3Text
                  text={(
                    <FontAwesomeIcon icon={faDownload} />
                  )}
                  className="action-button"
                />
              </div>
            </div>
          </div>
        ),
      },
    ];

    return qcColumns;
  };

  return (
    <Fragment>
      <Table
        bordered
        showHeader
        title={() => `Received Batches (${selectedGRNLines?.length})`}
        size="small"
        columns={getQCColumns()}
        dataSource={selectedGRNLines || []}
        pagination={false}
        scroll={{ x: 'max-content' }}
      />
      <Drawer
        open={showApproveQualityCheck}
        width="900px"
        onClose={() => {
          setShowApproveQualityCheck(false);
          callback();
        }}
        destroyOnClose
      >
        <ApproveQC
          onClose={() => {
            setShowApproveQualityCheck(false);
            callback();
          }}
          selectedQC={selectedQC}
          callback={() => {
            setShowApproveQualityCheck(false);
            callback();
          }}
          isCarryForward
        />
      </Drawer>
    </Fragment>
  );
};

const mapStateToProps = ({
  UserReducers, QCPointReducers, CategoryReducers, ProductReducers,
}) => ({
  user: UserReducers.user,
  createQCPointLoading: QCPointReducers.createQCPointLoading,
  updateQCPointLoading: QCPointReducers.updateQCPointLoading,
  categories: CategoryReducers.categories,
  products: ProductReducers.products,
});

const mapDispatchToProps = (dispatch) => ({
  createQCPoint: (payload, callback) => dispatch(QCPointActions.createQCPoint(payload, callback)),
  updateQCPoint: (payload, callback) => dispatch(QCPointActions.updateQCPoint(payload, callback)),
  getProducts: (keyword, tenantId, stockStatus, limit, page, tenantDepartmentId, excludeOutOfStock, productType, category, isSalesProduct, isPurchaseProduct) => dispatch(ProductActions.getProducts(keyword, tenantId, stockStatus, limit, page, tenantDepartmentId, excludeOutOfStock, productType, category, isSalesProduct, isPurchaseProduct)),
  getDownloadQualityChecks: (tenantId, qualityCheckId) => dispatch(
    QualityCheckActions.getDownloadQualityChecks(tenantId, qualityCheckId),
  ),
});

QualityCheckGRN.propTypes = {
  user: PropTypes.any,
  selectedGRNLines: PropTypes.any,
  callback: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(QualityCheckGRN));
